(function(){
  /* ── mega menu + compact header ── */
  var nav = document.querySelector("nav.top");
  if(nav){
    var trig = nav.querySelector(".shop-trigger");
    var mega = document.getElementById("megaShop");
    var canHover = window.matchMedia("(hover: hover)").matches;
    var closeTimer;
    function setShop(open){
      clearTimeout(closeTimer);
      nav.classList.toggle("shop-open", open);
      if(trig) trig.setAttribute("aria-expanded", open ? "true" : "false");
    }
    if(trig && mega){
      if(canHover){
        trig.addEventListener("mouseenter", function(){ setShop(true); });
        mega.addEventListener("mouseenter", function(){ setShop(true); });
        trig.addEventListener("mouseleave", function(){ closeTimer = setTimeout(function(){ setShop(false); }, 180); });
        mega.addEventListener("mouseleave", function(){ closeTimer = setTimeout(function(){ setShop(false); }, 180); });
      }
      trig.addEventListener("click", function(e){
        if(window.innerWidth > 980){ e.preventDefault(); setShop(!nav.classList.contains("shop-open")); }
      });
      document.addEventListener("keydown", function(e){
        if(e.key === "Escape" && nav.classList.contains("shop-open")){ setShop(false); trig.focus(); }
      });
      document.addEventListener("click", function(e){ if(!nav.contains(e.target)) setShop(false); });
    }
    var ticking = false;
    window.addEventListener("scroll", function(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){ nav.classList.toggle("compact", window.scrollY > 70); ticking = false; });
    }, {passive:true});

    /* sticky header: the section wrapper pins at -strip height so the strip scrolls away and the nav stays */
    var strip = document.querySelector(".strip");
    function setStripH(){ if(strip) document.documentElement.style.setProperty("--strip-h", strip.offsetHeight + "px"); }
    setStripH();
    window.addEventListener("resize", setStripH, {passive:true});

    /* ── mobile drawer ── */
    var mbtn = nav.querySelector(".menu-btn");
    var drawer = document.getElementById("tgDrawer");
    var dbg = document.querySelector(".drawer-bg");
    function setMenu(open){
      if(!drawer) return;
      drawer.classList.toggle("open", open);
      if(dbg) dbg.classList.toggle("open", open);
      if(mbtn) mbtn.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";
      if(open){ var inp = drawer.querySelector("input[type=search]"); if(inp) setTimeout(function(){ inp.focus({preventScroll:true}); }, 280); }
    }
    if(mbtn && drawer){
      mbtn.addEventListener("click", function(){ setMenu(!drawer.classList.contains("open")); });
      if(dbg) dbg.addEventListener("click", function(){ setMenu(false); });
      var dclose = drawer.querySelector(".drawer-close");
      if(dclose) dclose.addEventListener("click", function(){ setMenu(false); });
      document.addEventListener("keydown", function(e){ if(e.key === "Escape" && drawer.classList.contains("open")) setMenu(false); });
    }
  }

  /* ── scroll reveal ── */
  if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches && "IntersectionObserver" in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add("on"); io.unobserve(en.target); } });
    }, {threshold:.15});
    document.querySelectorAll(".rv").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".rv").forEach(function(el){ el.classList.add("on"); });
  }

  /* ── hero video: respect reduced motion ── */
  var hv = document.querySelector(".hero-bg");
  if(hv && window.matchMedia("(prefers-reduced-motion: reduce)").matches){ hv.removeAttribute("autoplay"); hv.pause(); }
})();

/* ── TGKit: shared kit state + tier discounts (cornerstone) ── */
(function(){
  var KEY="tg-kit";
  var TIERS=[{min:2,pct:1,code:"KIT1"},{min:3,pct:2,code:"KIT2"},{min:4,pct:3,code:"KIT3"},{min:5,pct:4,code:"KIT4"},{min:6,pct:5,code:"KIT5"},{min:8,pct:6,code:"KIT6"}];
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY))||{}; }catch(e){ return {}; } }
  function write(k){ try{ localStorage.setItem(KEY, JSON.stringify(k)); }catch(e){} document.dispatchEvent(new CustomEvent("tg-kit-updated")); }
  function count(k){ var n=0; for(var id in k) n+=k[id].qty; return n; }
  function tierFor(n){ var t=null; TIERS.forEach(function(x){ if(n>=x.min) t=x; }); return t; }
  function applyTier(n){
    var t=tierFor(n); if(!t) return Promise.resolve(null);
    /* sets Shopify's discount cookie so the code applies at checkout */
    return fetch("/discount/"+t.code, {method:"GET", credentials:"same-origin"}).then(function(){ return t; }).catch(function(){ return t; });
  }
  function addToCart(items){
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw new Error("cart"); return r.json(); })
      .then(function(d){ return fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
        var cc=document.getElementById("cartCount"); if(cc)cc.textContent=c.item_count;
        return applyTier(c.item_count).then(function(){ return c; });
      });});
  }
  window.TGKit={ read:read, write:write, count:count, tierFor:tierFor, applyTier:applyTier, addToCart:addToCart, TIERS:TIERS };

  /* auto-apply best tier on cart page so checkout carries the code */
  if(document.body && document.body.className.indexOf("template-cart")>-1){
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      if(c.item_count<2) return;
      applyTier(c.item_count).then(function(t){
        if(!t) return;
        var totals=document.querySelector(".cart-totals .note");
        if(totals) totals.textContent="Bundle code "+t.code+" ("+t.pct+"% off) applies at checkout · shipping & taxes calculated there too";
      });
    });
  }
})();

/* ── TGCart: slide-out mini cart drawer ── */
(function(){
  var drawer=document.getElementById("cartDrawer");
  if(!drawer) return;
  var bg=document.getElementById("cdBg"),
      body=document.getElementById("cdBody"),
      sub=document.getElementById("cdSubtotal"),
      disc=document.getElementById("cdDisc"),
      prog=document.getElementById("cdProgress"),
      ctEl=document.getElementById("cdCount"),
      closeBtn=document.getElementById("cdClose"),
      expandBtn=document.getElementById("cdExpand");
  var TIERS=(window.TGKit&&TGKit.TIERS)||[{min:2,pct:1},{min:3,pct:2},{min:4,pct:3},{min:5,pct:4},{min:6,pct:5},{min:8,pct:6}];
  var CART=[], busy=false, opened=false;

  function money(c){ return "$"+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,",").replace(/\.00$/,""); }
  function esc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/"/g,"&quot;"); }

  function closeMenu(){
    var md=document.getElementById("tgDrawer"); if(md) md.classList.remove("open");
    var mbg=document.querySelector(".drawer-bg"); if(mbg) mbg.classList.remove("open");
  }
  function open(){
    closeMenu();
    drawer.classList.add("open"); if(bg) bg.classList.add("open");
    drawer.setAttribute("aria-hidden","false");
    document.documentElement.style.overflow="hidden";
    opened=true; fetchCart();
  }
  function close(){
    drawer.classList.remove("open"); if(bg) bg.classList.remove("open");
    drawer.setAttribute("aria-hidden","true");
    document.documentElement.style.overflow="";
    opened=false;
  }

  function fetchCart(){
    fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();})
      .then(function(c){ CART=c.items||[]; render(); })
      .catch(function(){ render(); });
  }

  function render(){
    var count=0, subtotal=0;
    CART.forEach(function(it){ count+=it.quantity; subtotal+=it.final_price*it.quantity; });
    if(ctEl) ctEl.textContent=count;
    var hc=document.getElementById("cartCount"); if(hc) hc.textContent=count;
    drawer.classList.toggle("empty", count===0);
    if(count===0){ body.innerHTML=""; return; }

    body.innerHTML=CART.map(function(it,i){
      var note=(it.variant_title && it.variant_title!=="Default Title") ? it.variant_title : "";
      return '<div class="cd-line" data-i="'+i+'">'+
        '<div class="cd-thumb">'+(it.image?'<img src="'+esc(it.image)+'" alt="" loading="lazy">':'')+'</div>'+
        '<div class="cd-info">'+
          '<b><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a></b>'+
          (note?'<span class="cd-note">'+esc(note)+'</span>':'')+
          '<span class="cd-each">'+money(it.final_price)+' each</span>'+
          '<div class="cd-stepper" role="group" aria-label="Quantity">'+
            '<button type="button" data-d="-1" aria-label="Decrease quantity">&minus;</button>'+
            '<span class="n">'+it.quantity+'</span>'+
            '<button type="button" data-d="1" aria-label="Increase quantity">+</button>'+
          '</div>'+
        '</div>'+
        '<div class="cd-right">'+
          '<span class="cd-lt">'+money(it.final_price*it.quantity)+'</span>'+
          '<button type="button" class="cd-remove">Remove</button>'+
        '</div>'+
      '</div>';
    }).join("");

    if(sub) sub.textContent=money(subtotal);

    var pct=0, idx=-1; TIERS.forEach(function(t,i){ if(count>=t.min){ pct=t.pct; idx=i; } });
    if(prog){
      var bars='<div class="cd-bars">'+TIERS.map(function(t,i){ return '<div class="cd-bar'+(i<=idx?' lit':'')+'"></div>'; }).join("")+'</div>';
      var msg;
      if(pct===0){ msg=(count===1?"One more item unlocks <b>1% off</b> the kit.":"Add a second item to unlock bundle savings."); }
      else if(pct<6){ var next=null; TIERS.forEach(function(t){ if(!next && count<t.min) next=t; }); msg=(next.min-count)+" more reach"+(next.min-count===1?"es":"")+" <b>"+next.pct+"% off</b> — saving "+money(subtotal*pct/100)+" now."; }
      else { msg="Top tier — <b>6% off</b> everything."; }
      prog.innerHTML=bars+'<span>'+msg+'</span>';
    }
    if(disc){ disc.textContent=pct?("Bundle "+pct+"% applied at checkout"):""; disc.style.display=pct?"":"none"; }

    if(window.TGKit) TGKit.applyTier(count);
  }

  function change(i, qty){
    if(busy) return; busy=true;
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({line:i+1, quantity:qty})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(c){ CART=c.items||[]; busy=false; render(); })
      .catch(function(){ busy=false; fetchCart(); });
  }

  body.addEventListener("click", function(e){
    var line=e.target.closest(".cd-line"); if(!line) return;
    var i=+line.dataset.i;
    if(e.target.closest(".cd-remove")){ change(i,0); return; }
    var b=e.target.closest(".cd-stepper button"); if(!b) return;
    var cur=CART[i]?CART[i].quantity:1;
    var next=Math.max(0, Math.min(99, cur+(+b.dataset.d)));
    if(next!==cur) change(i,next);
  });

  var cartbtn=document.querySelector(".cartbtn");
  if(cartbtn) cartbtn.addEventListener("click", function(e){
    if(e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); open();
  });
  if(closeBtn) closeBtn.addEventListener("click", close);
  if(bg) bg.addEventListener("click", close);
  if(expandBtn) expandBtn.addEventListener("click", function(){
    var w=drawer.classList.toggle("wide");
    expandBtn.setAttribute("aria-pressed", w?"true":"false");
  });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape" && opened) close(); });

  window.TGCart={ open:open, close:close, refresh:fetchCart };
})();
